// extracted by mini-css-extract-plugin
export default {"mainBody":"Main_mainBody__iztQV","mainBody__title":"Main_mainBody__title__tFbn3","mainBody__subtitle":"Main_mainBody__subtitle__5OzQe"};